import PushLog from "@/components/incentives/PushLog"
import SendPushButton from "@/components/incentives/SendPushButton"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import type { Incentive } from "@/hooks/useIncentives"

// sendable is false once the incentive has ended or been cancelled, which leaves just the log.
// blocker says why a sendable incentive can't be sent yet.
type Props = { incentive: Incentive; sendable: boolean; disabled: boolean; blocker: string | null }

export default function PushNotificationsCard({ incentive, sendable, disabled, blocker }: Props) {
  return (
    <Card role="region" aria-label="Push notifications">
      <CardHeader className="border-b border-palette-jungleGreen100 pb-4 flex flex-row items-center justify-between gap-4 space-y-0">
        <div>
          <CardTitle className="text-lg text-palette-jungleGreen900">Push notifications</CardTitle>
          {sendable && (
            <p className="text-xs leading-relaxed text-palette-jungleGreen600 mt-1">
              Starts from the saved App Comms, which you can reword before it goes. It goes to every
              driver in the audience and opens the shifts page when tapped.
            </p>
          )}
        </div>
        {sendable && (
          <SendPushButton incentive={incentive} disabled={disabled || Boolean(blocker)} />
        )}
      </CardHeader>
      <CardContent className="pt-6 space-y-4">
        {sendable && blocker && <p className="text-sm text-palette-jungleGreen700">{blocker}</p>}
        <PushLog incentive={incentive} />
      </CardContent>
    </Card>
  )
}
